/**
 * 404 Not Found page with dark mode support
 */

import { Link } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';
import Button from '../components/ui/Button';
import { cn } from '../lib/utils';
import { useSEO, SEO_CONFIGS } from '../hooks/useSEO';

export default function NotFoundPage() {
  // SEO meta tags for 404 page
  useSEO(SEO_CONFIGS.notFound);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 px-4 transition-colors">
      <div className="text-center">
        <div className={cn(
          'w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6',
          'bg-amber-100 dark:bg-amber-900/30',
          'text-amber-600 dark:text-amber-400'
        )}>
          <AlertTriangle className="w-10 h-10" />
        </div>
        <h1 className="text-4xl font-bold text-neutral-900 dark:text-white mb-4">404</h1>
        <h2 className="text-xl font-semibold text-neutral-700 dark:text-neutral-300 mb-2">
          Página não encontrada
        </h2>
        <p className="text-neutral-500 dark:text-neutral-400 mb-8 max-w-md mx-auto">
          A página que você está procurando não existe ou foi movida.
        </p>
        <Link to="/">
          <Button icon={<Home className="w-4 h-4" />}>
            Voltar para o início
          </Button>
        </Link>
      </div>
    </div>
  );
}
